import { AxiosResponse } from "axios";
import axios from "./config";

import {
  AssignStoreApiPayload,
  AssignStoreApiResponse,
  Configurations,
  GetAssignedStoresApiResponse,
  GetBranchesAndStoresApiResponse,
  GetConfigurationsAPIResponse,
  GetPrivilegesApiResponse,
  GetStaffPermissionsApiResponse,
  PermissionAssignmentPayload,
  PermissionsListAPIResponse,
  PermissionsListByPrivilegeIdAPIResponse,
  PostAssignPermissionToPrivilegeApiResponse,
  PostStaffApiPayload,
  PostStaffApiResponse,
  PutPermissionsApiResponse,
  StaffListApiResponse,
} from "app/types/permissions";
import AuthAxios from "./auth";
import { AssignPermissionsPayload } from "app/redux/slice/permissionsSlice";

export const getPermissionsListApi = (): Promise<
  AxiosResponse<PermissionsListAPIResponse>
> => AuthAxios.get<PermissionsListAPIResponse>(`/permissions`);

export const putPermissionsApi = (
  identityId: number,
  payload: AssignPermissionsPayload
): Promise<AxiosResponse<PutPermissionsApiResponse>> =>
  AuthAxios.put<PutPermissionsApiResponse>(
    `/identity/${identityId}/permissions`,
    payload
  );

export const getStaffListApi = (
  query?: string
): Promise<AxiosResponse<StaffListApiResponse>> =>
  axios.get<StaffListApiResponse>(`/staffs${query ? query : ""}`);

export const postStaffApi = (
  payload: PostStaffApiPayload
): Promise<AxiosResponse<PostStaffApiResponse>> => {
  return axios.post<PostStaffApiResponse>(`/staffs`, payload);
};
export const putStaffApi = (
  identityId: number,
  payload: PostStaffApiPayload
): Promise<AxiosResponse<PostStaffApiResponse>> => {
  return axios.put<PostStaffApiResponse>(`/staffs/${identityId}`, payload);
};

export const getStaffPermissionsApi = (
  identityId: number
): Promise<AxiosResponse<GetStaffPermissionsApiResponse>> => {
  return AuthAxios.get<GetStaffPermissionsApiResponse>(
    `staffs/${identityId}/permissions`
  );
};

export const getPrivilegesApi = (): Promise<
  AxiosResponse<GetPrivilegesApiResponse>
> => {
  return AuthAxios.get<GetPrivilegesApiResponse>(`/privileges`);
};

export const getAssignedStoresApi = (
  identityId: number
): Promise<AxiosResponse<GetAssignedStoresApiResponse>> => {
  return axios.get<GetAssignedStoresApiResponse>(
    `/staffs/${identityId}/restricted-access`
  );
};

export const getBranchesAndStoresApi = (): Promise<
  AxiosResponse<GetBranchesAndStoresApiResponse>
> => {
  return axios.get<GetBranchesAndStoresApiResponse>(
    `/staffs/store/storesAndBranches`
  );
};
export const postAssignStoreApi = (
  payload: AssignStoreApiPayload
): Promise<AxiosResponse<AssignStoreApiResponse>> => {
  return axios.post<AssignStoreApiResponse>(
    `/staffs/store/assignStaff`,
    payload
  );
};
export const removeAssignStoreApi = (
  payload: AssignStoreApiPayload
): Promise<AxiosResponse<AssignStoreApiResponse>> => {
  return axios.post<AssignStoreApiResponse>(
    `/staffs/store/removeStaff`,
    payload
  );
};

export const getPermissionsByPrivilegeIdApi = (
  privilegeId: number
): Promise<AxiosResponse<PermissionsListByPrivilegeIdAPIResponse>> => {
  return AuthAxios.get<PermissionsListByPrivilegeIdAPIResponse>(
    `/Privileges/${privilegeId}/permissions`
  );
};

export const postAssignPermissionToPrivilegeApi = (
  payload: PermissionAssignmentPayload
): Promise<AxiosResponse<PostAssignPermissionToPrivilegeApiResponse>> => {
  return AuthAxios.post<PostAssignPermissionToPrivilegeApiResponse>(
    `/Privileges/${payload.privilegeId}/assign-permissions`,
    payload
  );
};

export const postRemovePermissionFromPrivilegeApi = (
  privilegeId: number,
  permissions: number[]
): Promise<AxiosResponse<PostAssignPermissionToPrivilegeApiResponse>> => {
  return AuthAxios.post<PostAssignPermissionToPrivilegeApiResponse>(
    `/Privileges/${privilegeId}/remove-permissions`,
    { privilegeId, permissions }
  );
};

export const getConfigurationsApi = (
 storeId: number
): Promise<AxiosResponse<GetConfigurationsAPIResponse>> => {
  return axios.get<GetConfigurationsAPIResponse>(
    `/Configurations/${storeId}`
  );
};

export const putConfigurationsApi = (
  storeId: number,
  payload: Configurations
  ): Promise<AxiosResponse<GetConfigurationsAPIResponse>> => {
  return axios.put<GetConfigurationsAPIResponse>(
    `/Configurations/${storeId}`,
   payload
  );
};